import React from 'react';
import type { Principle } from '../../types/content';
import { Reveal } from '../motion/Reveal';
type PrinciplesListProps = {
  items: Principle[];
  columns?: 2 | 4;
};
export function PrinciplesList({
  items,
  columns = 2
}: PrinciplesListProps) {
  return <ul className={`grid gap-x-12 gap-y-12 sm:grid-cols-2 ${columns === 4 ? 'lg:grid-cols-4 lg:gap-x-10' : 'lg:gap-x-20'}`} data-id="element-341" data-mp="28g5tg67czafq">
      {items.map((item, index) => <Reveal as="li" key={item.title} delay={index * 70} className="border-t border-navy/15 pt-7" data-id="element-342" data-mp="2hhnf043jc4bt" data-mpi={index}>
          <span aria-hidden="true" className="-mt-[29px] block h-[3px] w-10 bg-gold" data-id="element-343" data-mp="2dhd1m6deybmx" />
          <h3 className="mt-7 font-serif text-[1.65rem] font-medium leading-tight text-navy" data-id="element-344" data-mp="2r8i55jjwjo2j">{item.title}</h3>
          <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-345" data-mp="2map04tuc503u">{item.description}</p>
        </Reveal>)}
    </ul>;
}